import React, { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";

import { IgTypography } from "@intelligems/ig-theme";
import {
  DiscountQuantityWidget,
  DiscountQuantityWidgetStyles,
  DottedJoin,
} from "@intelligems/ig-types";
import { Grid } from "@mui/material";

import {
  selectedWidget,
  setQuantityWidgetStyleSettings,
} from "../../../store/slices/widgets";
import {
  IgColorPickerGroup,
  IgColorPickerGroupItems,
} from "../../../utils/IgColorPickerGroup";

interface QuantityWidgetAppearanceSettingsProps {
  configType: "desktop" | "mobile";
}
export const DiscountQuantityWidgetAppearanceSettings = ({
  configType,
}: QuantityWidgetAppearanceSettingsProps) => {
  const quantityWidget = useSelector(selectedWidget) as DiscountQuantityWidget;
  const dispatch = useDispatch();
  const items = useMemo<IgColorPickerGroupItems>(() => {
    return [
      [
        {
          key: "primaryColor",
          label: "Primary Color",
          path: `config[${[configType]}].styles.colors.primary`,
          value:
            quantityWidget.config[configType]?.styles?.colors?.primary ||
            quantityWidget.config.desktop?.styles?.colors?.primary ||
            "",
        },
        {
          key: "secondaryColor",
          label: "Secondary Color",
          path: `config[${configType}].styles.colors.secondary`,
          value:
            quantityWidget.config[configType]?.styles?.colors?.secondary ||
            quantityWidget.config.desktop?.styles?.colors?.secondary ||
            "",
        },
        {
          key: "borderColor",
          label: "Border Color",
          path: `config[${[configType]}].styles.colors.border`,
          value:
            quantityWidget.config[configType]?.styles?.colors?.border ||
            quantityWidget.config.desktop?.styles?.colors?.border ||
            "",
        },
      ],
    ];
  }, [quantityWidget]);

  const onFieldChange = (
    key: DottedJoin<DiscountQuantityWidgetStyles>,
    value: string
  ) => {
    dispatch(
      setQuantityWidgetStyleSettings({
        key,
        value,
      })
    );
  };

  return (
    <Grid item container direction={"column"} rowSpacing={2}>
      <Grid item>
        <IgTypography sx={{ fontWeight: 600, fontSize: "14px" }}>
          Button Colors
        </IgTypography>
      </Grid>
      <Grid item>
        <IgColorPickerGroup
          id={"quantity-widget"}
          items={items}
          onChange={onFieldChange}
          disabled={false}
        />
      </Grid>
    </Grid>
  );
};
